import React, { useState } from 'react';
import Sidebar from './Sidebar';
import BackToTop from './BackToTop';
import PWAInstallPrompt from './PWAInstallPrompt';
import PriorityAnnouncement from './PriorityAnnouncement';
import { useAuth } from '../contexts/AuthContext';

type LayoutProps = {
  children: React.ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  const { loading, userData } = useAuth();
  const [isBackToTopVisible, setIsBackToTopVisible] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  return (
    <>
      <Sidebar isBackToTopVisible={isBackToTopVisible}>
        {children}
      </Sidebar>
      <BackToTop onVisibilityChange={setIsBackToTopVisible} />
      <PWAInstallPrompt />
      {userData?.LoggedIn && <PriorityAnnouncement />}
    </>
  );
} 